import { store } from '@/store'

export const getCollectionColor = (collectionId) => {
  if (!collectionId) return 'gray-400'

  // Define colors for different goal collections
  const colorMap = {
    1: 'green-500',
    2: 'blue-500',
    3: 'purple-500',
    4: 'yellow-500',
    5: 'indigo-500',
  }

  // Return the color for the collection, or a default color if not found
  return colorMap[collectionId] || 'gray-400'
}

export const getCollectionTitle = (collection) => {
  const locale = store.state.cmsLocale
  console.log('!!! locale', locale)
  const translation = collection.translations.find(t => t.locale.code === locale)
  if (translation) {
    return translation.title
  }
  return collection.defaultTranslation?.title || ''
}
